import { TipoItem, Udm } from "../../../isp.žapi.servicios/constantesApiServicios";

const TipoItemLabel = {};
TipoItemLabel[TipoItem.PlanInternet] = "Plan.Int.";
TipoItemLabel[TipoItem.ServiciosGen] = "Serv. Gen.";
TipoItemLabel[TipoItem.Articulo] = "Articulo";
    
const UnidadItemLabel = {}
UnidadItemLabel[Udm.Mensual] = "Mensual";
UnidadItemLabel[Udm.Unidad] = "Unid.";

const EstadosItemLabel = {
    HAB: "Habilitado",
    DHAB: "En Baja",
};

const EstadoDeudorLabel = {
    alDia: "Al día",
    adeudado: "Adeudado",
};

const EstadoActividadLabel = {
    activo: "Activo",
    dadoBaja: "Dado d. Baja",
    suspendAC: "Susp./ AC",
    suspendFP: "Susp. / FP",
};

export {EstadoDeudorLabel, EstadoActividadLabel, EstadosItemLabel, TipoItemLabel, UnidadItemLabel};
